<template>
    <div class="content">
        <el-row :gutter="20">
            <el-col :span="17">
                <el-form ref="form" :model="form" class="flxz">
                    <el-col :span="23">
                    <el-form-item>
                      <el-input type="textarea" :rows="20" placeholder="" v-model="form.content" :style="{width:'100%'}" @input="renew($event)"></el-input>
                    </el-form-item>
                    </el-col>
                    <el-col :span="23">
                    <el-form-item size="large" label-width="0" style="text-align:center;">
                        <el-button type="primary" @click="submit">确定</el-button>
                        <el-button type="danger" @click="cancel">取消</el-button>
                    </el-form-item>
                    </el-col>
                </el-form>
            </el-col>
            <el-col :span="7">
              <ul class="zfmb">
                <li v-for="(item,index) in zfmbList" :key="index">
                  <p @click="getActive(index)"><i :class="isActive == index?'icon2':'icon1'" style="color:#ffaf47;"></i><b>{{item.zylbMc}}</b></p>
                  <div v-show="isActive == index" class="zfmb2">
                    <div v-for="(itema,i) in item.info" :key="i" :class="isActive2 == i?'dqSpan':''" @click="getXunwennr(itema,i)">
                      <span>
                        {{itema.mcjianxie}}
                        <b>{{itema.mc}}</b>
                      </span>
                    </div>
                  </div>
                </li>
              </ul>
          
            </el-col>
        </el-row>
        
    </div>
</template>

<script>
import axios from 'axios'
import qs from 'qs'
    export default {
      components: {},
      props: ['textXw'],
      data() {
        return {
          form:{
            content:'',
          },
          isActive:'-1',
          isActive2:'-1',
          zfmbList:[],
          baseUrl:''
        }
      },
      watch:{
        textXw(){
          this.form.content = ''
          this.isActive2 = '-1'
        }
      },
      created() {
        let user = JSON.parse(sessionStorage.getItem("userdata"));
        this.baseUrl = user.baseUrl
        this.getList();
      },
      async mounted() {
      },
      methods: {
        getList(){
          this.zfmbList = []
          axios({
                method: 'post',
                url: this.baseUrl+`/login/getZfmb`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    leibie:'违法事实',
                    find:''
                }
            })
            .then(response => {
                this.zfmbList = response.data.data || []
            })
            .catch(error => {
                console.error('There was an error!', error);
            });
        },
        renew(e){
          this.$forceUpdate()
        },
        submit(){
          this.$emit("handleBackShishi",this.form.content)
        },
        cancel(){
          this.$emit("shishiTk",false)
        },

        getActive(index){
          if(this.isActive == index){
            this.isActive = '-1'
          }else{
            this.isActive = index
          }
        },
        getXunwennr(itema,i){
          this.isActive2 = i
          if(this.form.content.indexOf(itema.mc) != '-1'){
            this.$message.error('不能重复添加')
          }else{
            this.form.content = this.form.content ? this.form.content + itema.mc : itema.mc
          }
        },
      }
    }
</script>

<style scoped>
.content{position: relative;}
.zfmb{ border:1px solid #DCDFE6; padding: 20px;max-height: 500px; overflow-y: auto;}
.zfmb li{line-height: 40px;}
.zfmb li p i{ width: 22px; height: 20px;float: left;; margin:10px 7px 0 0;}
.zfmb li p b{ cursor: pointer;}
.icon1{ background: url(../../../assets/images/wjjm.png);}
.icon2{ background: url(../../../assets/images/wjjm-a.png);}
.zfmb2{width: 100%;}
.zfmb2 span{ cursor: pointer; display: block; padding-left: 30px; background: url(../../../assets/images/wjj.png) no-repeat center left; margin-left: 30px;}
.zfmb2 span.dqSpan{color:#0C80E8;}
.zfmb2 span b{ display: none; position: absolute; top:40px;left: 120px; width: 600px; font-weight: normal; background:#303133; color: #fff;padding: 5px 10px;
    border-radius: 6px;}
.zfmb2 span:hover b{ display: block;}
.el-form >>> .el-textarea.is-disabled .el-textarea__inner { color: #333 !important;}
</style>
